// SPEC-UX §2.4: sem autenticação real ainda (H2/H3 em aberto, §B1 da
// SPEC-COMPASSO-v3). Placeholder documentado, único lugar que declara esse
// valor — nunca inventar como se fosse sessão real, nunca duplicar a string.
export const NOME_ATOR_PLACEHOLDER = 'Administrador';
